angular.module('dnecom').directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {

            // PARSERS
            ngModelCtrl.$parsers.push(function (text) {
                if (text) {
                    text = text.toString();
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (text.length > 1) {
                        transformedInput = transformedInput.replace(/^0+/, '');
                    }

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return '';
            });

            // FORMATTERS
            ngModelCtrl.$formatters.push(function (modelValue) {
                return (modelValue == 0) ? 0 : modelValue;
            });
        }
    };
});